import type { VisibleModule } from '@portal/contracts';
import { useEffect, useState } from 'react';
import { api, HttpError } from '../api.js';

type State = { kind: 'loading' } | { kind: 'ok'; module: VisibleModule } | { kind: 'error'; status: number };

/** Modulseite: fragt das Modul-Gate der API (serverseitige Prüfung), zeigt danach den Modul-Rahmen. */
export function ModulePage({ moduleKey }: { moduleKey: string }) {
  const [state, setState] = useState<State>({ kind: 'loading' });
  useEffect(() => {
    let alive = true;
    setState({ kind: 'loading' });
    api.module(moduleKey).then(
      (module) => alive && setState({ kind: 'ok', module }),
      (err: unknown) => alive && setState({ kind: 'error', status: err instanceof HttpError ? err.status : 0 }),
    );
    return () => {
      alive = false;
    };
  }, [moduleKey]);

  if (state.kind === 'loading') return <p className="sh-status">Wird geladen …</p>;
  if (state.kind === 'error') return <Problem status={state.status} />;
  return (
    <section className="mod">
      <h1 className="ap-title">{state.module.label}</h1>
      <div className="pb-card">
        <p>Dieses Modul ist für dich freigeschaltet und wird gerade gebaut.</p>
        {state.module.canConfigure && <p className="mod-note">Du darfst die Einstellungen dieses Moduls verwalten.</p>}
      </div>
    </section>
  );
}

/** Fehlerkarte; `anrede="sie"` für Module mit Sie-Form (#856 Royalty, PD-Review 187) — Standard bleibt du */
export function Problem({ status, anrede = 'du' }: { status: number; anrede?: 'du' | 'sie' }) {
  const sie = anrede === 'sie';
  const text =
    status === 403
      ? sie ? 'Für diesen Bereich fehlt Ihnen die Berechtigung.' : 'Für diesen Bereich hast du keine Berechtigung.'
      : status === 404
        ? 'Diese Seite gibt es nicht.'
        : status === 503
          ? sie ? 'Die Rechteprüfung ist gerade nicht erreichbar. Bitte versuchen Sie es gleich noch einmal.' : 'Die Rechteprüfung ist gerade nicht erreichbar. Bitte versuche es gleich noch einmal.'
          : sie ? 'Etwas ist schiefgelaufen. Bitte laden Sie die Seite neu.' : 'Etwas ist schiefgelaufen. Bitte lade die Seite neu.';
  return (
    <div className="pb-card sh-problem" role="alert">
      {text}
    </div>
  );
}
